import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { redemptionpointService } from '../redemptionpoint.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NavigationService } from '@app/shared/services/navigation-service.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { cloneDeep } from "lodash";
import { ToastService } from '@app/shared/services/toast.service';
import { LocalStorageService } from '@app/core/services/localStorageService';
import { FeatureFlagService } from '@app/shared/services/feature-flag.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-redemption-point-list',
  templateUrl: './redemption-point-list.component.html',
  styleUrls: ['./redemption-point-list.component.scss']
})
export class RedemptionPointListComponent implements OnInit, OnDestroy {

  @Input() pagePath = 'redemptionpoints';
  @Input() embedded = false;

  modalRef?: BsModalRef;
  deleteModalRef?: BsModalRef;
  public params: any;
  public exportparams: any;
  public totalItems: any;
  public dataList: any;
  public totalPages: any;
  public isEditMode: any = false;
  public totalPoints: any;
  public cities: any;
  public citiesWithoutAll: any;
  public rPoint: any;
  public isUserNameValid = true;
  public isPasswordValid = true;
  public idTodelete : any;
  public userNameEdit : string = "";
  public statusList: Array<{ value: string; labelKey: string }> = [];
  private langSub?: Subscription;
  public finishCU: any = false;
  public isSubmitted: any = false;

  constructor(public redemptionsService: redemptionpointService,
    public navigation: NavigationService,
    public spinner: NgxSpinnerService,
    public router: Router,
    private modalService: BsModalService,
    public toast: ToastService,
    public route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    public featureFlagService: FeatureFlagService,
    private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.spinner.show();
    this.buildStatusList();
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.buildStatusList();
      this.buildCityList();
    });
    this.initQueryParamMap();
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  private buildStatusList(): void {
    this.statusList = [
      { value: 'false', labelKey: 'store.redemptionPoints.allStatuses' },
      { value: 'true', labelKey: 'common.active' }
    ];
  }

  private buildCityList(): void {
    this.cities = [
      { value: -1, labelKey: 'store.redemptionPoints.allCities' },
      ...(this.citiesWithoutAll || [])
    ];
  }

  public statusLabel(status: string): string {
    return status === 'ACTIVE'
      ? this.translate.instant('common.active')
      : this.translate.instant('common.inactive');
  }

  public initQueryParamMap() {
    this.route.queryParamMap
      .subscribe((params: any) => {
        this.exportparams = {};
        this.params = params.params.page ? cloneDeep(params.params) : {
          page: 1,
          onlyActive: false
        };
        this.getItems();
      }
      );
  }


  public getItems() {
    this.redemptionsService.getRedemptionPoints(this.params).subscribe((res: any) => {
      this.dataList = res.content;
      this.totalItems = res.total;
      this.totalPages = Math.ceil(parseInt(res.total.toString()) / res.pageable.size);
      this.spinner.hide();
    }, error => {
      console.log(error);
      this.spinner.hide();

    });

    this.redemptionsService.getRedemptionPointCount(this.params).subscribe((res: any) => {
      this.totalPoints = res.count;
    }, error => {
      console.log(error);
    });

    var storedValue = this.localStorageService.getValueWithExpiry('countryCode');
    if (!storedValue) {
      storedValue = 'ps';
    }
    this.redemptionsService.getCities(storedValue).subscribe((res: any) => {
      this.citiesWithoutAll = res.content.map((city: { id: any, name: any; }) => ({
        value: city.id,
        label: city.name
      }));;
      this.buildCityList();
    }, error => {
      console.log(error);
    });


  }

  public onDone() {
    this.modalRef?.hide()
    this.navigation.refreshPage(this.pagePath, this.params);
    this.getItems();
  }

  public CreateRP() {
    this.isSubmitted = true;
    if (!this.isUserNameValid || !this.isPasswordValid || !this.rPoint.cityId?.toString()?.trim() ||!this.rPoint.userName.toString().trim() || !this.rPoint.password.toString().trim() || !this.rPoint.branchName.toString().trim()
    ) {
      return;
    }
    this.spinner.show();
    var rp = { ...this.rPoint, city: { id: this.rPoint.cityId } }
    this.redemptionsService.createRP(rp).subscribe((res: any) => {
      const message = this.translate.instant('store.redemptionPoints.toastCreated');
      this.toast.success(message);
      this.spinner.hide();
      this.finishCU = true;
    },
      error => {
        this.spinner.hide();
        console.log(error);
      })
  }

  public EditRP() {
    this.isSubmitted = true;
    if (!this.isUserNameValid || !this.isPasswordValid || !this.rPoint.userName.toString().trim() || !this.rPoint.password.toString().trim() || !this.rPoint.branchName.toString().trim()
    ) {
      return;
    }

    this.spinner.show();
    var rp = { ...this.rPoint, city: { id: this.rPoint.cityId } }
    this.redemptionsService.UpdateRP(rp).subscribe((res: any) => {
      const message = this.translate.instant('store.redemptionPoints.toastUpdated');
      this.toast.success(message);
      this.spinner.hide();
      this.finishCU = true;
    },
      error => {
        this.spinner.hide();
        console.log(error);
      })
  }

  public confirmDelete(){
    this.redemptionsService.deleteRp(this.idTodelete).subscribe((res: any) => {
      const message = this.translate.instant('store.redemptionPoints.toastDeleted');
      this.spinner.hide();
      this.deleteModalRef?.hide();
      this.toast.success(message);
      this.getItems();
    },
      error => {
        this.spinner.hide();
        console.log(error);
      });
  }

  public cancelDelete(){
    this.deleteModalRef?.hide();
  }

  public onCreateRpoint(rpointTemplate: any) {
    this.isEditMode = false;
    this.isSubmitted = false;
    this.finishCU = false;
    this.rPoint = <Rpoint>{};
    if(this.citiesWithoutAll.length > 0)
    {
    this.rPoint.cityId = this.citiesWithoutAll[0].value;
    }
    this.rPoint.isActive = true;
    this.isUserNameValid = true;
    this.isPasswordValid = true;
    this.modalRef = this.modalService.show(rpointTemplate);
  }

  public CreateAnother() {
    this.isEditMode = false;
    this.isSubmitted = false;
    this.finishCU = false;
    this.rPoint = <Rpoint>{};
    this.rPoint.cityId = this.citiesWithoutAll[0].value;
    this.isUserNameValid = true;
    this.isPasswordValid = true;
    this.rPoint.isActive = true;
  }

  public onEditRpoint(rp: any, rpointTemplate: any, pop: any) {
    this.isUserNameValid = true;
    this.isPasswordValid = true;
    this.isEditMode = true;
    this.isSubmitted = false;
    this.finishCU = false;
    this.rPoint = <Rpoint>{};
    this.rPoint.userName = rp.userName;
    this.userNameEdit = rp.userName;
    this.rPoint.isActive = rp.isActive;
    this.rPoint.branchName = rp.branchName;
    this.rPoint.password = rp.password;
    this.rPoint.id = rp.id;
    this.rPoint.cityId = rp?.city?.id;
    this.rPoint.isActive = rp.status == "INACTIVE" ? false : true;
    pop.hide()
    this.modalRef = this.modalService.show(rpointTemplate);
  }

  public onRemoveRpoint(id: any, deleterpointTemplate:any, pop: any) {
    this.idTodelete = id;
    pop.hide()
    this.deleteModalRef = this.modalService.show(deleterpointTemplate);
  }


  changeCity(value: any) {
    if (value == -1) {
      delete this.params.cityId;
    }
    else {
      this.params.cityId = value;
    }
    this.params.page = 1;
    this.navigation.refreshPage(this.pagePath, this.params);
  }

  changeCreatedCity(value: any) {
    this.rPoint.cityId = value;
  }

  changeStatus(value: any) {
    this.params.onlyActive = value;
    this.params.page = 1;
    this.navigation.refreshPage(this.pagePath, this.params);
  }

  backClick(event: any) {
    this.params.page--;
    this.navigation.refreshPage(this.pagePath, this.params);
  }

  nextClick(event: any) {
    this.params.page++;
    this.navigation.refreshPage(this.pagePath, this.params);
  }

  doSearchByEnter(val: any) {
    this.params.page = 1;
    this.params.searchKey = val?.target?.value;
    this.navigation.refreshPage(this.pagePath, this.params);

  }

  doSearchByKeyUp(event: any) {
    this.params.searchKey = event.target.value;
    if (this.params.searchKey.length > 3 && event.key !== 'Enter') {
      this.params.page = 1;
      this.navigation.refreshPage(this.pagePath, this.params);
    }
    if (this.params.searchKey.length === 0) {
      delete this.params.searchKey;
      this.navigation.refreshPage(this.pagePath, this.params);
    }
  }

  userNameSearchByKeyUp(event: any) {
    var uName = event.target.value;
    if (this.isEditMode && this.userNameEdit === uName)
    {
      this.isUserNameValid = true;
      return;
    }
    this.redemptionsService.verifyName(uName).subscribe((res: any) => {
      this.isUserNameValid = res.isAvailable;
    });
  }
  passwordSearchByKeyUp(event: any) {
    var password = event.target.value;
    if (password.length < 8){
      this.isPasswordValid = false;
    }
    else{
      this.isPasswordValid = true;
    }
  }

}

interface Rpoint {
  id: number;
  userName: string;
  password: string;
  branchName: string;
  cityId: number;
  isActive: boolean;
}
